<div class="status-container">
    <h3 class="title">{{ 'store.status.title' | translate }}</h3>
    <ul class="list">
        <li>
            <i class="icon" [ngClass]="getIcon(data.hasStoreHours)"></i>
            {{ 'store.status.storeHours' | translate }}
        </li>
        <li>
            <i class="icon" [ngClass]="getIcon(data.hasPrepTime)"></i>
            {{ 'store.status.prepTime' | translate }}
        </li>
        <li>
            <i class="icon" [ngClass]="getIcon(data.hasAggregator)"></i>
            {{ 'store.status.channelEnabled' | translate }}
        </li>

        <li>
            <i class="icon" [ngClass]="getIcon(data.isOnlineAndReady)"></i>
            {{ 'store.status.onlineAndReady' | translate }}
        </li>
        <li>
            <i class="icon" [ngClass]="getIcon(data.hasDefaultTaxRate)"></i>
            {{ 'store.status.defaultTaxRate' | translate }}
        </li>
        <li>
            <i class="icon" [ngClass]="getIcon(data.isStatusOpen)"></i>
            {{ 'store.status.isOpenStore' | translate }}
        </li>
    </ul>
</div>
